<ng-container *ngIf="gridThumbnails.length > 0">
    <div class="editor-header">
        <nb-actions size="small">
            <nb-action (click)="goBack($event)">
                <nb-icon icon="arrow-back-outline" pack="eva" title="Back"></nb-icon>Back
            </nb-action>
        </nb-actions>
        <div>Edit Cells - {{selectedSection?.sectionId}}</div>
    </div>
    <div *ngFor="let cell of cellIdsThumbs;let i=index" class="section-thumbnail input-cell">
        <div class="thumbnail-img">
            <ng-container *ngIf="cell?.imgSrc;else altPlaceHolder">
                <img src="{{cell.imgSrc}}">
            </ng-container>
            <ng-template #altPlaceHolder>
                <img src="https://placehold.co/75x110?text=NO-IMG">
            </ng-template>
        </div>
        <div class="edit-options">
            <ng-container [ngSwitch]="cell?.content">
                <ng-container *ngSwitchCase="'image'">
                    <nb-actions size="small">
                        <nb-action
                            (click)="open({action:'image',imgSrc:cell.imgSrc,cellId:cell.cellId,bgImgSrc:cell.bgImgSrc,enum:cell.contentEnum})">
                            <nb-icon icon="image-outline" pack="eva" title="Edit Image"></nb-icon>Image -
                            {{cell.cellId}}
                        </nb-action>
                    </nb-actions>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <nb-actions size="small">
                        <nb-action (click)="open({action:'content',imgSrc:thumbnail,cellId:cell.cellId})">
                            <nb-icon icon="browser-outline" pack="eva" title="Edit Header"></nb-icon>
                            <ng-container *ngIf="cell?.content != undefined;else noContent">
                                {{cell?.content}}
                            </ng-container>
                            <ng-template #noContent>
                                Unspecified - {{cell.cellId}}
                            </ng-template>
                        </nb-action>
                    </nb-actions>
                </ng-container>
            </ng-container>
            <nb-actions size="small">
                <nb-action (click)="open({action:'layout',imgSrc:thumbnail})">
                    <nb-icon icon="layout-outline" pack="eva" title="Edit Layout"></nb-icon>Layout
                </nb-action>
                <nb-action (click)="open({action:'theme',imgSrc:thumbnail})">
                    <nb-icon icon="color-palette-outline" pack="eva" title="Edit Theme"></nb-icon>Theme
                </nb-action>
                <nb-action (click)="open({action:'link',imgSrc:thumbnail})">
                    <nb-icon icon="link-2-outline" pack="eva" title="Edit Link"></nb-icon>Link
                </nb-action>
            </nb-actions>
        </div>
    </div>
</ng-container>